export default __webpack_public_path__ + "static/media/face_1_19.da7a1cf0.png";